<template>
    <lottie :options="options" :height="height" :width="width" v-on:animCreated="handleAnimation"/>
</template>

<script>
  export default {
    props: {
      options: Object,
      height: {
        type: Number,
        default: 150
      },
      width: {
        type: Number,
        default: 150
      },
      animationSpeed: {
        type: Number,
        default: 1
      },
    },
    methods: {
      handleAnimation (anim) {
        this.anim = anim
      },
      loopComplete(){
        this.anim.stop()
      }
    }
  }
</script>